
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternOff as ObiLightLanternOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-off.js';
 
 
 

 
 export const ObiLightLanternOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-off',
   elementClass: ObiLightLanternOffElement,
   events: {
     
   }
  });
 
 